/* Scroll-linked zoom: one observer, one frame per scroll, visible images only. */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!('IntersectionObserver' in window)) return;
  var active = new Set();
  var known = new Set();
  var frame = 0;
  function update() {
    frame = 0;
    if (reduced.matches) return;
    var height = window.innerHeight;
    var measurements = Array.from(active).map(function (element) {
      var rect = element.getBoundingClientRect();
      var progress = Math.max(0, Math.min(1, (height - rect.top) / (height + rect.height)));
      return [element, 1 + progress * 0.2];
    });
    measurements.forEach(function (item) { item[0].style.setProperty('--zoom-in-ratio', item[1]); });
  }
  function schedule() {
    if (!frame && active.size && !reduced.matches) frame = requestAnimationFrame(update);
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) active.add(entry.target);
      else active.delete(entry.target);
    });
    schedule();
  });
  function scan(scope) {
    scope.querySelectorAll('.animate--zoom-in').forEach(function (element) {
      if (known.has(element)) return;
      known.add(element);
      observer.observe(element);
    });
  }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  reduced.addEventListener('change', function () {
    if (reduced.matches) {
      cancelAnimationFrame(frame);
      frame = 0;
      known.forEach(function (element) { element.style.removeProperty('--zoom-in-ratio'); });
    } else schedule();
  });
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    known.forEach(function (element) {
      if (!event.target.contains(element)) return;
      observer.unobserve(element);
      active.delete(element);
      known.delete(element);
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); }, { once: true });
  else scan(document);
}());
